/** Widths the bars cycle through, so a skeleton reads as lines of text rather than a block. */
const LINE_WIDTHS = ['w-[92%]', 'w-[78%]', 'w-[85%]', 'w-[64%]', 'w-[88%]', 'w-[56%]'] as const

interface SkeletonProps {
  /** How many bars stand where the rows will be. */
  lines?: number
  /** What is on its way, for a screen reader ("Loading the board"). */
  label?: string
  /** Padding and placement of the surrounding screen. */
  className?: string
}

/**
 * What a section shows while its one read is on its way (the loading standard, design screen 10, 26 October 2026):
 * grey bars in the shape of the rows to come, so the page doesn't jump when they arrive, in place of a "Loading…"
 * line. A view that waits on several reads gets the loading window as well (`useLoadingWindow`).
 */
export function Skeleton({ lines = 3, label = 'Loading', className = '' }: SkeletonProps) {
  return (
    <div role="status" aria-label={label} className={`flex flex-col gap-2.5 ${className}`}>
      {Array.from({ length: lines }, (_, index) => (
        <div key={index} aria-hidden="true" className={`h-2.5 rounded bg-marine/10 motion-safe:animate-pulse ${LINE_WIDTHS[index % LINE_WIDTHS.length]}`} />
      ))}
      <span className="sr-only">{label}…</span>
    </div>
  )
}
